import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const portfolioData = [
  {
    categoryKey: 'portfolio.p1.category',
    titleKey: 'portfolio.p1.title',
    descKey: 'portfolio.p1.desc',
    tagKey: 'portfolio.p1.tag',
    filterKey: 'portfolio.cat.litho',
    image: 'https://static.readdy.ai/image/f6265e0f35e672632603158b994d4cb8/b198944bcee5c8664910997b8b5c2246.webp',
  },
  {
    categoryKey: 'portfolio.p2.category',
    titleKey: 'portfolio.p2.title',
    descKey: 'portfolio.p2.desc',
    tagKey: 'portfolio.p2.tag',
    filterKey: 'portfolio.cat.xenon',
    image: 'https://static.readdy.ai/image/f6265e0f35e672632603158b994d4cb8/75e9f2b3bd3cbe72286886ac391b55d8.jpeg',
  },
  {
    categoryKey: 'portfolio.p3.category',
    titleKey: 'portfolio.p3.title',
    descKey: 'portfolio.p3.desc',
    tagKey: 'portfolio.p3.tag',
    filterKey: 'portfolio.cat.rtp',
    image: 'https://static.readdy.ai/image/f6265e0f35e672632603158b994d4cb8/ece2f6e704a6891823733b42ad3b6671.png',
  },
  {
    categoryKey: 'portfolio.p4.category',
    titleKey: 'portfolio.p4.title',
    descKey: 'portfolio.p4.desc',
    tagKey: 'portfolio.p4.tag',
    filterKey: 'portfolio.cat.align',
    image: 'https://static.readdy.ai/image/f6265e0f35e672632603158b994d4cb8/0fd5ee63d628a236311d6906aa94c713.png',
  },
  {
    categoryKey: 'portfolio.p5.category',
    titleKey: 'portfolio.p5.title',
    descKey: 'portfolio.p5.desc',
    tagKey: 'portfolio.p5.tag',
    filterKey: 'portfolio.cat.cure',
    image: 'https://static.readdy.ai/image/f6265e0f35e672632603158b994d4cb8/76c1b51971b42139c57e7929fd19d82f.png',
  },
  {
    categoryKey: 'portfolio.p6.category',
    titleKey: 'portfolio.p6.title',
    descKey: 'portfolio.p6.desc',
    tagKey: 'portfolio.p6.tag',
    filterKey: 'portfolio.cat.rtp',
    image: 'https://static.readdy.ai/image/f6265e0f35e672632603158b994d4cb8/4845d730a0ec276912554bc589d0e190.jpeg',
  },
];

const categoryKeys = [
  'portfolio.cat.all',
  'portfolio.cat.litho',
  'portfolio.cat.xenon',
  'portfolio.cat.rtp',
  'portfolio.cat.align',
  'portfolio.cat.cure',
];

export default function PortfolioSection() {
  const { t } = useTranslation();
  const [activeFilter, setActiveFilter] = useState('portfolio.cat.all');

  const filtered = activeFilter === 'portfolio.cat.all'
    ? portfolioData
    : portfolioData.filter(item => item.filterKey === activeFilter);

  return (
    <section id="portfolio" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#1B3F7A]/20 bg-[#1B3F7A]/5 mb-6">
              <span className="w-2 h-2 rounded-full bg-[#1B3F7A] inline-block" />
              <span className="text-[#1B3F7A] text-xs tracking-widest uppercase font-medium">{t('portfolio.badge')}</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-gray-900 leading-tight">
              {t('portfolio.title1')}<br /><span className="text-[#1B3F7A]">{t('portfolio.title2')}</span>
            </h2>
          </div>
          <p className="text-gray-500 text-base leading-relaxed max-w-sm md:text-right">
            {t('portfolio.desc')}
          </p>
        </div>

        <div className="flex flex-wrap gap-2 mb-10">
          {categoryKeys.map(catKey => (
            <button
              key={catKey}
              onClick={() => setActiveFilter(catKey)}
              className={`px-4 py-1.5 rounded-full text-xs font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap ${
                activeFilter === catKey
                  ? 'bg-[#1B3F7A] text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              {t(catKey)}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map(item => (
            <div
              key={item.titleKey}
              className="group rounded-2xl overflow-hidden bg-gray-50 cursor-pointer hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-full h-52 overflow-hidden">
                <img
                  src={item.image}
                  alt={t(item.titleKey)}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2 mb-3">
                  <span className="px-3 py-1 rounded-full bg-[#1B3F7A]/10 text-[#1B3F7A] text-xs font-semibold">
                    {t(item.tagKey)}
                  </span>
                  <span className="text-gray-400 text-xs">{t(item.categoryKey)}</span>
                </div>
                <h3 className="font-bold text-gray-900 text-base mb-2 leading-snug">{t(item.titleKey)}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{t(item.descKey)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
